import * as log from 'loglevel';
import api from 'src/utils/api';

import {
  FETCH_TAG_POSTS,
  FETCH_TAG_POSTS_SUCCESS,
  FETCH_TAG_POSTS_FAILURE,
  FETCH_TAG_COMMUNITIES,
  FETCH_TAG_COMMUNITIES_SUCCESS,
  FETCH_TAG_COMMUNITIES_FAILURE,
  FETCH_NHS_TAG_CONTENT,
  FETCH_NHS_TAG_CONTENT_SUCCESS,
  FETCH_NHS_TAG_CONTENT_FAILURE,
} from './actionTypes';

import { setAlert } from 'src/typescript/components/alert/actions';
import paginationResultsPerPage from 'src/constants/paginationResultsPerPage';

export const fetchTagPosts = (tagName: string, currentPage: number, communityFilter: string, sortBy: string) => {
  return async (dispatch: any, getState: any) => {
    dispatch({
      type: FETCH_TAG_POSTS,
      tagName,
      currentPage,
      communityFilter,
      sortBy,
    });
    if (!tagName) return;

    try {
      const isSortByDate = sortBy === 'newest';
      const limit = paginationResultsPerPage.search;
      const start = limit * (currentPage - 1);
      const lang = getState().context.lang;

      const params: any = {
        q: tagName,
      };

      if (start !== 0) {
        params.start = start;
      }

      if (communityFilter !== 'all') {
        params['community-ids'] = communityFilter;
      }

      if (isSortByDate) {
        // default sort is by relevance
        params['sort-by'] = 'date';
      }

      if (lang !== 'en') {
        params.lang = lang;
      }

      const response = await api.getPublic('search/posts', { params });
      const { data: { posts, communityAggregates, total } } = response;

      dispatch({
        type: FETCH_TAG_POSTS_SUCCESS,
        totalResults: total,
        results: posts,
        communityFilterOptions: communityAggregates,
      });

    } catch (ex) {
      log.error(ex);
      dispatch({ type: FETCH_TAG_POSTS_FAILURE });
      dispatch(setAlert(ex.message));
    }
  };
};

export const fetchTagCommunities = (tagName: string, currentPage: number) => {
  return async (dispatch: any, getState: any) => {
    dispatch({
      type: FETCH_TAG_COMMUNITIES,
      tagName,
      currentPage,
    });
    if (!tagName) return;

    try {
      const limit = paginationResultsPerPage.searchCommunities;
      const start = limit * (currentPage - 1);
      const lang = getState().context.lang;

      const params: any = {
        q: tagName,
      };

      if (start !== 0) {
        params.start = start;
      }

      if (lang !== 'en') {
        params.lang = lang;
      }

      const response = await api.getPublic('search/communities', { params });
      const { data: { communities, total } } = response;

      dispatch({
        type: FETCH_TAG_COMMUNITIES_SUCCESS,
        totalResults: total,
        results: communities,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: FETCH_TAG_COMMUNITIES_FAILURE });
      dispatch(setAlert(ex.message));
    }
  };
};

export const fetchNHSTagContent = (tagName: string, tagType: string) => {
  return async (dispatch: any) => {
    dispatch({ type: FETCH_NHS_TAG_CONTENT });

    try {
      const response = await api.getPublic(`nhs-tag/${tagType}/${tagName}`);
      const { data: { content, attributionLogo, attributionUrl } } = response;

      if (content === null) {
        return dispatch({ type: FETCH_NHS_TAG_CONTENT_FAILURE });
      }

      dispatch({
        type: FETCH_NHS_TAG_CONTENT_SUCCESS,
        content,
        attributionLogo,
        attributionUrl,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: FETCH_NHS_TAG_CONTENT_FAILURE });
    }
  };
};
